import autoload from "./autoload";
import auth from './mixins/auth';
import cart from './mixins/cart';
import initDom from './mixins/init_dom';
import videoList from './components/videos/videoList.vue';

autoload();

window.app = new Vue({
  el: '#vue-videos',
  mixins: [initDom, auth, cart],

  components: {
    videoList
  },
});